import { useMemo } from "react";
import { isArray } from "lodash";

import { useUserRoleSelector } from "../../store";
import { IRole, IRoleName } from "../../store/types";

export function useRoleGuardHook<DataType>(
  data: DataType,
  availableRoles: IRoleName | IRoleName[],
  forbid?: boolean
): DataType | undefined {
  const role: IRole | null = useUserRoleSelector();

  return useMemo(() => {
    if (!role || forbid) return;

    const { name } = role;

    if (typeof availableRoles === "string" && name === availableRoles) {
      return data;
    }

    if (isArray(availableRoles) && availableRoles.includes(name)) {
      return data;
    }
  }, [data, availableRoles, role, forbid]);
}
